import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import type { DMAcceptorStartBlocker } from '@nsftx/systems-sdk';
import type { AcceptorStartBlockersData, AcceptorType } from '../types';

const useDmAcceptorsStore = defineStore('dmAcceptorsStore', () => {
  const acceptorStartBlockers = ref<AcceptorStartBlockersData>({
    bill: [],
    coin: [],
  });

  const acceptorStartBlockersExist = computed(
    () => !!(acceptorStartBlockers.value.bill.length || acceptorStartBlockers.value.coin.length),
  );

  const setAcceptorStartBlockers = (
    blockers: AcceptorStartBlockersData | DMAcceptorStartBlocker[],
    acceptor?: AcceptorType,
  ) => {
    if (!acceptor) {
      const { bill, coin } = blockers as AcceptorStartBlockersData;
      acceptorStartBlockers.value = {
        ...acceptorStartBlockers.value,
        bill: [...bill],
        coin: [...coin],
      };

      return;
    }

    acceptorStartBlockers.value = {
      ...acceptorStartBlockers.value,
      [acceptor]: [...(blockers as DMAcceptorStartBlocker[])],
    };
  };

  return {
    acceptorStartBlockers,
    acceptorStartBlockersExist,
    setAcceptorStartBlockers,
  };
});

export {
  useDmAcceptorsStore,
};
